function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.048 9C5.414 8.145 5 7.127 5 6a6 6 0 0 1 11-3.318A6 6 0 0 1 27 6c0 1.127-.414 2.145-1.048 3H31.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H30v14.5a.5.5 0 0 1-.5.5h-27a.5.5 0 0 1-.5-.5V17H.5a.5.5 0 0 1-.5-.5v-7A.5.5 0 0 1 .5 9h5.548zM7 6a4 4 0 0 1 8-.004V6c0 .522-.005 1.004-.01 1.442-.005.608-.01 1.13-.001 1.558h-6.06a5.84 5.84 0 0 1-.348-.252C7.578 7.962 7 6.974 7 6zm5 5v4H2v-4h10zm2 0v4h4v-4h-4zm9.072-2c.119-.08.235-.164.347-.252C24.422 7.962 25 6.974 25 6a4 4 0 0 0-8 0c0 .522.005 1.004.01 1.442.005.608.01 1.13.001 1.558h6.06zM20 11v4h3v2h-3v13h8V17h-1v-2h3v-4H20zm-2 19V17h-4v13h4zM4 17h8v13H4V17z",
  clipRule: "evenodd"
});

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "77fc451d1a11eec0c1560b3ad8b2b351.svg";
export { SvgGift as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/gift.svg
// module id = null
// module chunks = 